/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-extra-semi */
import { TokenResultView } from '../api'

const WISORY_USER_STORAGE_KEY = 'wisory_user_login_data'

export const getUserData = (): TokenResultView | null | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any)._wisoryUser
}

export const getUserDataFromLocalStorage = () => {
  try {
    const userLoginData = localStorage.getItem(WISORY_USER_STORAGE_KEY)

    if (!userLoginData) {
      return null
    }

    const token: TokenResultView = JSON.parse(userLoginData)
    if (!token.refreshToken) {
      return null
    }

    return token
  } catch {
    return null
  }
}

export const setUserData = (data: TokenResultView) => {
  ;(window as any)._wisoryUser = data
}

export const deleteUserData = () => {
  ;(window as any)._wisoryUser = null
}

export const setUserDataToLocalStorage = (data: TokenResultView) => {
  localStorage.setItem(WISORY_USER_STORAGE_KEY, JSON.stringify(data))
}

export const deleteUserDataFromLocalStorage = () => {
  localStorage.removeItem(WISORY_USER_STORAGE_KEY)
}
